import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EglenceTarifeGetAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "EglenceTarifeGet";
        super(baseUrl);
    }

    getEglenceTarifeGet(yili: number, gelirKodu?: number, gelirAltKodu?: number) {
        return this.get("", { params: { yili: yili, gelirKodu: gelirKodu, gelirAltKodu: gelirAltKodu } });

    }
}
export default new EglenceTarifeGetAPI();